"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
exports.isObject = function (item) { return item && typeof item === 'object' && !Array.isArray(item); };
exports.deepMerge = function (target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    if (!sources.length) {
        return target;
    }
    // making sure to not change target (immutable)
    var output = tslib_1.__assign({}, target);
    sources.forEach(function (source) {
        if (exports.isObject(source)) {
            Object.keys(source).forEach(function (key) {
                if (exports.isObject(source[key])) {
                    if (!output[key]) {
                        output[key] = tslib_1.__assign({}, source[key]);
                    }
                    else {
                        output[key] = exports.deepMerge(output[key], source[key]);
                    }
                }
                else {
                    output[key] = source[key];
                }
            });
        }
    });
    return output;
};
exports.removeUndefined = function (obj) {
    var result = {};
    Object.keys(obj).forEach(function (key) {
        if (obj[key] !== undefined) {
            result[key] = obj[key];
        }
    });
    return result;
};
//# sourceMappingURL=object.js.map